// Tasarım sistemi tokenları. Admin panelinden değiştirilip Firestore'a (settings/theme) yazılır.
// Buradaki değerler varsayılandır; Firestore'da kayıt yoksa bunlar kullanılır.
export const defaultTheme = {
  preset: "usta",
  colors: {
    primary: "#1B7FD8",   // ana marka rengi (butonlar, vurgular) - tabela mavisinin AA uyumlu tonu
    accent: "#F2A900",    // ikincil vurgu (rozetler, ikon arka planları)
    dark: "#0B1A2E",      // hero ve footer zemini - tabela zemini
    bg: "#F5F8FC",        // sayfa zemini
    surface: "#FFFFFF",   // kart zemini
    text: "#111827",
    muted: "#5B6472",
    border: "#DCE4EE",
  },
  fonts: {
    heading: "Manrope",
    body: "Inter",
  },
  radius: 14,           // px, kart/buton köşe yuvarlaklığı
  headerStyle: "light", // "light" | "dark"
  heroStyle: "dark",    // "dark" | "light"
};

export const fontOptions = [
  { heading: "Manrope", body: "Inter", label: "Manrope + Inter (modern)" },
  { heading: "Barlow", body: "Source Sans 3", label: "Barlow + Source Sans (atölye)" },
  { heading: "Sora", body: "Inter", label: "Sora + Inter (teknik)" },
  { heading: "Playfair Display", body: "Source Sans 3", label: "Playfair + Source Sans (klasik)" },
  { heading: "Poppins", body: "Roboto", label: "Poppins + Roboto (yumuşak)" },
  { heading: "Space Grotesk", body: "IBM Plex Sans", label: "Space Grotesk + Plex (endüstriyel)" },
];
